import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/styles/global.css'
import App from './App.vue'
import router from './router/router.js'

const app = createApp(App)
app.use(ElementPlus)
app.use(router)
app.mount('#app')
